import { atom } from "jotai";

/**
 * Primitives
 */

/**
 * Atom to store the authentication token retrieved from the Keycloak.
 * This token should be sent whenever a request is made to fetch data from the backend
 */
export const authTokenAtom = atom<string>("");
// Atom to handle the visibility of the home page as session is maintained through OIDC
export const showHomePageAtom = atom<boolean>(false);
export const canLoadAppAtom = atom<boolean>(false);
